export const getMedicorePatientLink = (medicorePatientId?: string | null) => {
  if (!medicorePatientId) return "";

  return `${import.meta.env.VITE_MEDICORE_URL}/#patient/details/${medicorePatientId}`;
};
